<div class="ziro-admin-page-content">
  <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
  <div class="col-md-10 offset-md-1" [hidden]="isLoading">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="52"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
      <ziro-text [fieldId]="'secret'">
        @if (proxyKey) {
          <ziro-button
            [dataAutomation]="'generate-key-copy-button'"
            [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
            [cssClass]="'btn-input-copy'"
            [cdkCopyToClipboard]="proxyKey"
            [isDisabled]="!entity?.secret"
            #t="ngbTooltip"
            [triggers]="'click'"
            [ngbTooltip]="'tkey;admin.webex_authentication.copy_button_clicked' | translate"
            [icon]="ziroIcons.COPY"
            (clicked)="onCopyUriClick(t)"
          ></ziro-button>
        }
      </ziro-text>
    </ziro-collapsible-section-card>
    @if (healthStatusAlertCss) {
      <div
        class="mt-3 alert"
        data-automation="generate-key-health-status"
        [ngClass]="healthStatusAlertCss"
        [innerHTML]="healthStatusAlertText | escapeHtml"
      ></div>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
